export const MIN_TABLET = 'min-width: 768px';
export const MIN_DESKTOP = 'min-width: 1100px';
